import { RouteRecordRaw } from 'vue-router'

import { RESIDENCY_ROUTE_NAMES } from '@/modules/residency/constants/ResidencyRouteNames'

import { UserGroup } from '@generated/types'

export const residencyRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/residency',
    name: RESIDENCY_ROUTE_NAMES.LIST,
    component: () => import('@/modules/residency/pages/ResidencyList.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency',
    },
  },
  {
    path: '/venue/residency/:residencyId',
    name: RESIDENCY_ROUTE_NAMES.DETAIL,
    component: () => import('@/modules/residency/pages/ResidencyDetail.vue'),
    props: route => {
      const residencyId = route.params.residencyId
      return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
    },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency Detail',
    },
  },
]
